'use client';
import {
  Step,
  StepLabel,
  Stepper,
  Typography,
  useMediaQuery,
} from '@mui/material';
import stepLabelClasses from '@mui/material/StepLabel/stepLabelClasses';
import useTheme from '@mui/material/styles/useTheme';
import CheckCircleIcon from '@treyd-io/treyd-ui/icons/CheckCircleIcon';
import ChevronRightIcon from '@treyd-io/treyd-ui/icons/ChevronRightIcon';

export type StepperStepStatus = 'completed' | 'not_completed';
export interface StepperStep {
  label: string;
  status: StepperStepStatus;
}

interface DialogStepperProps {
  steps: StepperStep[];
  activeStep: number;
}

export const DialogStepper = (props: DialogStepperProps) => {
  const theme = useTheme();
  const isSmallScreens = useMediaQuery(theme.breakpoints.down('md'));
  if (isSmallScreens) return;

  return (
    <Stepper
      activeStep={props.activeStep}
      connector={<ChevronRightIcon color="disabled" fontSize="small" />}
      sx={{ width: '100%' }}>
      {props.steps.map((step, index) => (
        <Step
          key={step.label}
          sx={{
            paddingInlineStart: index === 0 ? 0 : 1,
          }}>
          <StepLabel
            StepIconComponent={(stepProps) =>
              (stepProps.completed ||
                (step.status === 'completed' &&
                  index !== props.activeStep)) && (
                <CheckCircleIcon
                  fontSize="small"
                  color={'secondary'}
                  sx={{ marginRight: 1 }}
                />
              )
            }
            sx={{
              paddingInlineStart: index === 0 ? 0 : 1,
              [`& .${stepLabelClasses.iconContainer}`]: {
                paddingRight: 0,
              },
            }}>
            <Typography
              variant="subtitle2"
              color={
                props.activeStep === index ? 'text.primary' : 'text.disabled'
              }>
              {index + 1}. {step.label}
            </Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};
